export default __webpack_public_path__ + "static/media/jour.a333bd6d.png";